export const FALLBACK_DEMO_SERVICES = [
  {
    id: 'demo-service-quick',
    name: 'Quick Check-in',
    duration: 30,
    bufferTime: 0,
    price: 45,
    description: 'Short follow-up slot',
  },
  {
    id: 'demo-service-consult',
    name: 'Consultation',
    duration: 45,
    bufferTime: 15,
    price: 75,
    description: 'Initial consultation',
  },
  {
    id: 'demo-service-standard',
    name: 'Standard Session',
    duration: 60,
    bufferTime: 10,
    price: 95,
    description: 'Regular appointment',
  },
  {
    id: 'demo-service-premium',
    name: 'Premium Service',
    duration: 90,
    bufferTime: 15,
    price: 140,
    description: 'Extended session',
  },
];
